import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { AuthQuery } from '@auth/state/auth.query';

import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(private router: Router, private authQuery: AuthQuery) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const token = this.authQuery.token();

    const copiedReq = request.clone({
      headers: request.headers.append('authorization', 'Bearer ' + token),
    });

    return next.handle(copiedReq).pipe(
      tap(
        (event) => {},
        (error) => {
          if (this.router.url !== '/auth/login' && error.status === 401) {
            this.router.navigate(['/auth/login']);
          }
          return error;
        }
      )
    );
  }
}
